import { render, staticRenderFns } from "./PaxelMarketMeta.vue?vue&type=template&id=95be0a9a&"
import script from "./PaxelMarketMeta.vue?vue&type=script&lang=js&"
export * from "./PaxelMarketMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports